import { OIDC } from "@theprelude/core";
import { GoogleIconPlain, OidcIcon, PasswordIcon } from "@theprelude/ds";

export function SignInMethod({ oidc }: { oidc: OIDC }) {
  if (oidc === "") {
    return (
      <div className="flex items-center gap-1">
        <PasswordIcon className="text-secondary-foreground" />
        <span>Password</span>
      </div>
    );
  }

  switch (oidc) {
    case "google": {
      return (
        <div className="flex items-center gap-1">
          <GoogleIconPlain className="text-secondary-foreground" />
          <span>Google</span>
        </div>
      );
    }
    default: {
      return (
        <div className="flex items-center gap-1">
          <OidcIcon className="text-secondary-foreground" />
          <span>OpenID Connect</span>
        </div>
      );
    }
  }
}
